import { render, staticRenderFns } from "./timestatus.vue?vue&type=template&id=2ebd7a1e&scoped=true&"
import script from "./timestatus.vue?vue&type=script&lang=js&"
export * from "./timestatus.vue?vue&type=script&lang=js&"
import style0 from "./timestatus.vue?vue&type=style&index=0&id=2ebd7a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd7a1e",
  null
  
)

export default component.exports